const colors = {
  yoogaOld: {
    100: '#afdff7',
    200: '#6fc3ed',
    300: '#19A1E6',
    400: '#048cd1',
  },
  yooga: {
    '50': '#E8F6FD',
    '100': '#BFE5F8',
    '200': '#95D4F4',
    '300': '#6CC3EF',
    '400': '#42B2EB',
    '500': '#19A1E6',
    '600': '#1481B8',
    '700': '#0F618A',
    '800': '#0A405C',
    '900': '#05202E',
  },
  bg: {
    light: '#F5F5F5',
    dark: '#090D11',
  },
  yGray: {
    0: '#ffffff',
    50: '#f5f6f6',
    100: '#e5e7e8',
    200: '#ced2d3',
    300: '#abb2b5',
    400: '#abb2b5',
    500: '#5f676c',
    600: '#575e63',
    700: '#4b5053',
    800: '#424648',
    900: '#3a3d3f',
    950: '#242628',
    1000: '#000000',
  },
  yPrimary: {
    50: '#f1f9fe',
    100: '#e1f1fd',
    200: '#bde3fa',
    300: '#83cef6',
    400: '#41b5ef',
    500: '#19a1e6',
    600: '#0b7cbe',
    700: '#0a639a',
    800: '#0d547f',
    900: '#114769',
    950: '#0b2c46',
  },
  ySecondary: {
    50: '#fdf2f6',
    100: '#fce7f0',
    200: '#fbcfe1',
    300: '#faa7c7',
    400: '#f45b93',
    500: '#ee467f',
    600: '#dd255a',
    700: '#c01642',
    800: '#9e1638',
    900: '#841732',
    950: '#510618',
  },
  yYellow: {
    50: '#fdfde9',
    100: '#fdfbc4',
    200: '#fbf38d',
    300: '#f9e54b',
    400: '#f5d31a',
    500: '#f1c40f',
    600: '#c59009',
    700: '#9d670b',
    800: '#825211',
    900: '#6f4314',
    950: '#412307',
  },
  yGreen: {
    50: '#f0fdf5',
    100: '#dcfcea',
    200: '#bbf7d6',
    300: '#85f0b7',
    400: '#49df90',
    500: '#20bf6b',
    600: '#15a459',
    700: '#148148',
    800: '#16653c',
    900: '#145334',
    950: '#052e1a',
  },
  yOrange: {
    50: '#fff8f1',
    100: '#ffedd5',
    200: '#fed7aa',
    300: '#fdba74',
    400: '#fb923c',
    500: '#f97316',
    600: '#ea580c',
    700: '#c2410c',
    800: '#9a3412',
    900: '#7c2d12',
    950: '#431407',
  },
  yRed: {
    50: '#fff1f1',
    100: '#ffe1e1',
    200: '#ffc8c8',
    300: '#ffa2a1',
    400: '#fe5a59',
    500: '#f73d3c',
    600: '#e41f1e',
    700: '#c01615',
    800: '#9f1615',
    900: '#831a19',
    950: '#480707',
  },
};

export default colors;
